// extracted by mini-css-extract-plugin
export default {"TaxItem":"TaxItem_TaxItem__HEDfg","PriceWrapper":"TaxItem_PriceWrapper__H9GRO"};